<script>
let period=undefined;
import {apiUrl} from '../config.svelte';
import {onMount,onDestroy} from 'svelte';
import {Table} from 'sveltestrap';
let lines=[]
let conErr=false;
onMount(()=>{
    load(()=>{
        period = setInterval(()=>{
            load()
        },5000)
    })
    
    
})
function load(callback){
    fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"line-stat"}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                conErr=false;
                lines=x.data;
                if(callback)
                    callback()
            }else{
                conErr=true
                if(callback)
                   callback()
            }
        })
        .catch(()=>{
            conErr=true
            if(callback)
                callback()
        })
}
onDestroy(()=>{
    clearInterval(period)
})
</script>
<div style="padding:15px;">
    <Table bordered style="width:auto">
        <thead>
            <tr>
                <th>активность</th>
                <th>выделено линий</th>
            </tr>
        </thead>
        <tbody>
            {#each lines as line}
                <tr style={!line.activity?"font-weight:bold":""}>
                    <td>{line.activity?line.activity:'свободно'}</td>
                    <td>{line.clines}</td>
                </tr>
            {/each}
        </tbody>
    </Table>
</div>

